import { createPortal } from 'react-dom';
import { useState, useEffect } from 'react';
import _ from 'lodash';

export default function Portal({ children, portalRoot, closeAllComments }) {
  const [containerEl] = useState(document.createElement('div'));
  const [root, setRoot] = useState(null);

  useEffect(() => {
    function closeAllCommentsForDoc(e) {
      const path = _.get(e, 'path') || (e.composedPath && e.composedPath());
      if (path) {
        closeAllComments({ removeStale: true });
      }
    }
    if (portalRoot && portalRoot !== root) {
      containerEl.style = 'position: absolute; top: 0; left:0;';
      portalRoot.appendChild(containerEl);
      setRoot(portalRoot);
      portalRoot.addEventListener('click', closeAllCommentsForDoc);
    }
  }, [closeAllComments, containerEl, portalRoot, root]);

  if (!root) {
    return null;
  }
  return createPortal(children, containerEl);
}
